import { isAxiosError, isCancel } from 'axios';
import { ApiCancelledError } from './ApiCancelledError';
import { ApiNetworkError } from './ApiNetworkError';
import { ApiRequestError } from './ApiRequestError';

export const toApiError = (error: unknown): unknown => {
  if (!isAxiosError(error)) {
    return error;
  }

  if (isCancel(error)) {
    return new ApiCancelledError(error);
  }

  return error.response
    ? new ApiRequestError(error)
    : new ApiNetworkError(error);
};
